export default "__VITE_ASSET__B0p9esND__"